export default "__VITE_ASSET__CwIumVe0__"